<div class="container" [formGroup]="filters">
    <div class="half-container">
        <p class="title">{{'TITLE_REPORT_FIELDS' | translate }}</p>
        <p class="subtitle">{{"SUBTITLE_DEVICE_MANAGEMENT" | translate}}</p>
        
    </div>

    <div class="half-container">
        <div class="cardsContainer">
        <div class="card">
            <p class="textSelect">
                Device Incident Type 
            </p>
            <div class="select">
                <mat-form-field color="white" appearance="outline">
                    <mat-select #selIncidentType formControlName="incidentType"  multiple>
                        
                        <mat-option *ngFor="let option of arrayDevicesIncidentsTypes" [value]="option">{{option.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>

            </div>

        </div>
        <div class="card">
            <p class="textSelect">
                {{ "ENTER_DATE_RANGE" | translate }}
            </p>
            <div class="selectDate">
                <mat-form-field  appearance="outline" class="matformDate">
                    
                    <mat-date-range-input [rangePicker]="picker" >
                      <input matStartDate formControlName="start" #dateRangeStart >
                      <!-- (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" -->
                      <input matEndDate formControlName="end" #dateRangeEnd>
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
    

            </div>

        </div>
        <div class="card">
            <p class="textSelect">
                 Status
            </p>
            <div class="select">
                <mat-form-field color="white" appearance="outline" class="matformSelect-status">
                    <mat-select #selStatus formControlName="status"  multiple>
                        <mat-option *ngFor="let option of arrayReportStatus" [value]="option">{{option.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>

            </div>

        </div>
    </div>
    <div class="card1 button-card">
        <button mat-raised-button (click)="getCallFieldsDevicesReview()" > 
            <span class="confirm-ico-btn"></span> 
            {{ "SEARCH" | translate }}
        </button>
    </div>
    </div>
</div>

<neoris-grid [ColumnsConfiguration]="gridColumnsConfiguration"   [ShowChecks]="false" [GridTitle]="'SUBTITLE_DEVICE_MANAGEMENT' | translate" [Data]="arrayGirdFieldsReviewGrid"   (cellClickEvent)="cellClick($event)"></neoris-grid>
